import { render } from "./add-banner.vue?vue&type=template&id=7262d99a"
import script from "./add-banner.vue?vue&type=script&lang=js"
export * from "./add-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__